module.exports = __webpack_public_path__ + "img/flag.15a26af2.png";